import { useMutation } from "@apollo/client";

import { MapEditorObservationPanel_ObservationEcologicalFunctionCreateDocument } from "./mutations.generated";
import { MapEditorObservationPanelObservationEditableDocument } from "./queries.generated";

export function useLinkObservationToEcologicalFunctionMutation() {
    const [mutate, result] = useMutation(MapEditorObservationPanel_ObservationEcologicalFunctionCreateDocument, {
        refetchQueries: [MapEditorObservationPanelObservationEditableDocument],
    });

    const linkEcologicalFunction = (observationId: string, ecologicalFunctionId: string) =>
        mutate({
            variables: {
                input: {
                    observationId,
                    ecologicalFunctionId,
                },
            },
        });

    return [linkEcologicalFunction, result] as const;
}
